import useInactivityLogout from 'hooks/useInactivityLogout';
import { useLocation } from 'react-router-dom';

export default ({ timeout, user }) => {
  const setInactivityLogout = useInactivityLogout();

  useLocation(); // this is used only to trigger a re-render when navigating through the app
  setInactivityLogout(user ? timeout : 0);

  return null;
};
